import * as React from 'react';

import type { ShippingAddress } from 'types';

type Props = {
  shippingAddress: ShippingAddress,
  rowIndex: number
};

function hasShippingAddress(shippingAddress: ShippingAddress) {
  if (!shippingAddress) {
    return false;
  }

  const {
    recipient,
    address1,
    address2,
    city,
    zip,
    stateProvinceRegion,
    country
  } = shippingAddress;

  return recipient
    || address1
    || address2
    || city
    || zip
    || stateProvinceRegion
    || country;
}

const ShippingAddressesShippingAddress = (
  {
    shippingAddress,
    rowIndex
  }: Props
): JSX.Element => {
  const id = `shippingAddressesShippingAddress${rowIndex}`;

  if (!hasShippingAddress(shippingAddress)) {
    return (
      <div
        id={id}
        className="shipping-addresses__cell--centered"
      >
        –
      </div>
    );
  }

  return (
    <div id={id}>
      {
        shippingAddress.recipient && (
          <div>{shippingAddress.recipient}</div>
        )
      }
      {
        shippingAddress.address1 && (
          <div>{shippingAddress.address1}</div>
        )
      }
      {
        shippingAddress.address2 && (
          <div>{shippingAddress.address2}</div>
        )
      }
      {
        (shippingAddress.city || shippingAddress.zip) && (
          <div>
            {shippingAddress.zip}
            &nbsp;
            {shippingAddress.city}
          </div>
        )
      }
      {
        shippingAddress.stateProvinceRegion && (
          <div>{shippingAddress.stateProvinceRegion}</div>
        )
      }
      {
        shippingAddress.country && (
          <div>{shippingAddress.country}</div>
        )
      }
    </div>
  );
};

export default ShippingAddressesShippingAddress;
